import React from "react";
import { useTranslation } from "react-i18next";
import CardContainer from "../cardContainer";
import VehicleCardContent from "./vehicleCardContent";
import { getWorkTimeTypeColorClass } from "../../../models/workShitTimeSlot/workTimeType";
import { VehicleData } from "../../../models/monitorView/monitorViewTypes";
import { getVehicleStatusColorClass, getVehicleStatusDuration, getVehicleStatusText } from "../monitorViewUtils";

interface VehicleCardProps {
    vehicle: VehicleData;
    driver: string;
    isSelected: boolean;
    onClick: () => void;
}

const VehicleCard: React.FC<VehicleCardProps> = ({ vehicle, driver, isSelected, onClick }) => {
    const { t } = useTranslation();

    return (
        <CardContainer isSelected={isSelected} onClick={onClick}>
            <VehicleCardContent
                driver={driver ? driver : t("monitorView.noDriver")}
                mainTitle={vehicle.registerNumber}
                speed={`${vehicle.speed} km/h`}
                status={getVehicleStatusText(vehicle.driving)}
                subTitle={vehicle.brand}
                vehicleStatusDuration={getVehicleStatusDuration(vehicle.drivingGmt)}
                vehicleStatusIconClass={`text-${getVehicleStatusColorClass(vehicle.driving)}`}
                workTimeStatusIconClass={`text-${getWorkTimeTypeColorClass(vehicle.workTimeTypeType)}`}
                workTimeTypeName={vehicle.employeeWorkTimeTypes[0]?.workTimeTypeName || ""}
            />
        </CardContainer>
    );
};

export default VehicleCard;